export default __webpack_public_path__ + "media/images/sunflower-logo-3fcc1bcd419a3eeecab9d3b9c75feda5.svg";